if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	// FANCYBOX VIDEO
	$('.fancybox-video').fancybox({
		padding: 0,
		afterShow: function () {
			document.querySelector('.fancybox-inner video').play();
		},
		beforeClose: function () {
			document.querySelector('.fancybox-inner video').pause();
		}
	});

	$("#booking-form").submit(function(e){
		e.preventDefault(); 
		if (typeof ga === 'function') { ga('send', 'event', 'booking engine entrances', 'booking widget', 'header book now'); }
		setTimeout(function(){
			e.currentTarget.submit();
		}, 350);
	});
	$('.click-call').on('click', function() {
		if (typeof ga === 'function') { ga('send', 'event', 'phone calls', 'click ', 'calls'); }
	});
	$('.rfp-meeting').on('click', function() {
		if (typeof ga === 'function') { ga('send', 'event', 'request proposal', 'click ', 'meetings'); }
	});
	$('.rfp-wedding').on('click', function() {
		if (typeof ga === 'function') { ga('send', 'event', 'request proposal', 'click ', 'weddings'); }
	});
	$('.book-now').on('click', function() {
		var thisTitle = '';
		thisTitle = $(this).attr("aria-label")+' ';
		if (typeof ga === 'function') { ga('send', 'event', 'booking engine entrances', 'buttons ', thisTitle+'book now'); }
	});
	$('.book-now-mobile').on('click', function() {
		if (typeof ga === 'function') { ga('send', 'event', 'booking engine entrances', 'buttons ', 'header book now'); }
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	const customDots = (slider, i) => `<button>${i < 9 ? 0 : '' }${ i+1 }</button>`;

	// SLICK
	const prevArrowHTML =
		`<button class="slick-prev slick-arrow" aria-label="Prev" type="button">
			<svg width="50" height="50" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/arrow-left1.svg#arrow-left"></use>
			</svg>
		</button>`;
	const nextArrowtHTML =
		`<button class="slick-next slick-arrow" aria-label="Next" type="button">
			<svg width="50" height="50" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/arrow-right1.svg#arrow-right"></use>
			</svg>
		</button>`;

    $('.sym-slides').slick({
        accessibility: false,
        customPaging: customDots,
		prevArrow: prevArrowHTML,
		nextArrow: nextArrowtHTML

    });

    // FANCYBOX
	if ($.fancybox) {
		$.fancybox.defaults.tpl.closeBtn =
		`<a title="Close" class="fancybox-item fancybox-close" href="javascript:;">
			<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="/assets/svg/icon-close2.svg#icon-close"></use>
			</svg>
		</a>`;
		$.fancybox.defaults.tpl.prev =
			`<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;">
				<span>
					<svg width="50" height="50" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/assets/svg/arrow-left1.svg#arrow-left"></use>
					</svg>
				</span>
			</a>`;
		$.fancybox.defaults.tpl.next =
			`<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;">
				<span>
					<svg width="50" height="50" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
						<use xlink:href="/assets/svg/arrow-right1.svg#arrow-right"></use>
					</svg>
				</span>
			</a>`;
	}

})();